import React from 'react';
import 'components/ProductCard/ProductCard.scss';
import '../Loading.scss';
function LoadingProductCard() {
  return(
    <article className="c-product-card c-loading--product-card"></article>
  )
}

export default LoadingProductCard;